import React from 'react'

export const FlowerPot = props => (
  <svg
    width={25}
    height={25}
    viewBox='0 0 40 40'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clip-path="url(#clip0_8184_74785)">
      <path d="M10.0421 5.07809C10.0214 4.12927 10.796 3.35469 11.7448 3.37541C12.921 3.40111 14.5781 3.68591 16.2728 4.48571C17.216 4.93084 18.0622 5.50294 18.7795 6.22017C19.4007 6.84137 19.913 7.55929 20.3283 8.35319C20.3992 8.20486 20.4757 8.05926 20.5582 7.91656C21.1705 6.85599 22.068 6.00731 23.161 5.33526C24.3392 4.61094 25.4948 4.21252 26.3245 4.03856C27.1558 3.86422 27.9855 4.34314 28.2502 5.15034L28.4898 6.09854C28.7537 7.40412 28.8123 8.77097 28.526 10.1018C28.3742 10.807 28.128 11.4718 27.7748 12.0832C27.5125 12.5378 27.1975 12.9535 26.8373 13.3331H29.9998C31.8408 13.3331 33.3332 14.8255 33.3332 16.6664V19.9997C33.3332 21.2432 32.6523 22.3275 31.6432 22.9005C31.4122 29.0072 29.5188 33.2627 28.582 35.0164C27.9978 36.11 26.8763 36.6664 25.7745 36.6664H14.2251C13.1234 36.6664 12.0019 36.11 11.4176 35.0164C10.4809 33.2627 8.58745 29.0072 8.35644 22.9005C7.34729 22.3275 6.6665 21.2432 6.6665 19.9997V16.6664C6.6665 14.8255 8.15889 13.3331 9.99984 13.3331H14.4414C13.8745 12.9844 13.3534 12.5793 12.8869 12.1127C12.1696 11.3955 11.5975 10.5493 11.1524 9.60601C10.3526 7.91131 10.0678 6.25424 10.0421 5.07809Z"/>
    </g>
    <defs>
      <clipPath id="clip0_8184_74785">
        <rect width="40" height="40" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)
